<script>
  import { COMPONENT_MAP } from "$lib/components/ComponentMapBuilder.svelte";

  import RichText from "$lib/components/RichText.svelte";

  let clazz = "";
  export { clazz as class };
  export let body;
</script>

<div data-headings-increment class={clazz}>
  <RichText node={body} componentMap={COMPONENT_MAP} />
</div>
